(() => {
  const banner = document.querySelector('[data-grind-cookie-banner]');
  if (!banner || !window.Shopify?.loadFeatures) return;

  const choiceKey = 'grind-cookie-choice';
  const forcePreview = new URLSearchParams(window.location.search).has('preview_cookie');
  let hasChoice = false;
  try { hasChoice = Boolean(localStorage.getItem(choiceKey)); } catch (_) {}
  if (hasChoice && !forcePreview) return;

  const show = () => {
    if (document.querySelector('iframe[src*="preview-bar"]')) banner.classList.add('g-cookie--above-preview');
    banner.hidden = false;
  };

  const saveConsent = (accepted) => {
    const privacy = window.Shopify.customerPrivacy;
    if (!privacy) return;
    privacy.setTrackingConsent(
      {
        analytics: accepted,
        marketing: accepted,
        preferences: accepted
      },
      () => {
        try { localStorage.setItem(choiceKey, accepted ? 'accepted' : 'declined'); } catch (_) {}
        banner.hidden = true;
      }
    );
  };

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error) return;
      show();
      banner.querySelector('[data-cookie-accept]')?.addEventListener('click', () => saveConsent(true));
      banner.querySelector('[data-cookie-decline]')?.addEventListener('click', () => saveConsent(false));
    }
  );
})();
